import { EditorMode } from "./editor-mode.enum";
import { Meal } from "./meal.enum";
import { Option } from "./option.enum";

export const createDishInitialValue = {
  macros: Object.entries(Meal).reduce(
    (nutrition, [, meal]) => ({
      ...nutrition,
      [meal]: Object.entries(Option).reduce(
        (options, [, option]) => ({
          ...options,
          [option]: {
            [EditorMode.RestDay]: [],
            [EditorMode.TrainingDay]: [],
          },
        }),
        []
      ),
    }),
    {}
  ),
  suplementations: Object.entries(Meal).reduce(
    (suplementations, [, meal]) => ({
      ...suplementations,
      [meal]: [],
    }),
    {}
  ),
  nutrition: Object.entries(Meal).reduce(
    (nutrition, [, meal]) => ({
      ...nutrition,
      [meal]: Object.entries(Option).reduce(
        (options, [, option]) => ({
          ...options,
          [option]: undefined,
        }),
        []
      ),
    }),
    {}
  ),
};

export type CreateDishValues = typeof createDishInitialValue;
